/* tslint:disable */
/* eslint-disable */
/**
 * Car Repair Register API
 * Evidence of customers and vehicles for small workshops.
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerUpdate
 */
export interface CustomerUpdate {
    /**
     * 
     * @type {string}
     * @memberof CustomerUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUpdate
     */
    surname: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerUpdate
     */
    mobile: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerUpdate
     */
    email: string | null;
}

/**
 * Check if a given object implements the CustomerUpdate interface.
 */
export function instanceOfCustomerUpdate(value: object): value is CustomerUpdate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('mobile' in value) || value['mobile'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function CustomerUpdateFromJSON(json: any): CustomerUpdate {
    return CustomerUpdateFromJSONTyped(json, false);
}

export function CustomerUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'surname': json['surname'],
        'mobile': json['mobile'],
        'email': json['email'],
    };
}

export function CustomerUpdateToJSON(json: any): CustomerUpdate {
    return CustomerUpdateToJSONTyped(json, false);
}

export function CustomerUpdateToJSONTyped(value?: CustomerUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'mobile': value['mobile'],
        'email': value['email'],
    };
}

